import React, { useEffect, useRef, useCallback, useState } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const OurSkills = () => {
  const revealRefs = useRef([]);
  const addRevealRef = useCallback((el) => {
    if (el && !revealRefs.current.includes(el)) {
      revealRefs.current.push(el);
    }
  }, []);

  const barsRef = useRef([]);
  const [visible, setVisible] = useState(false);

  const skills = [
    { name: 'space planning and layout', percent: '95%' },
    { name: 'project challenges and solutions', percent: '85%' },
    { name: 'sustainability and eco-friendly features', percent: '75%' },
  ];

  useEffect(() => {
    // GSAP Reveal Animation for Images
    revealRefs.current.forEach((container) => {
      const image = container.querySelector('img');
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: container,
          toggleActions: 'play none none none',
        },
      });

      tl.set(container, { autoAlpha: 1 });
      tl.from(container, { duration: 1, ease: 'power2.out' });
      tl.from(image, {
        xPercent: 100,
        scale: 1,
        delay: -1,
        duration: 1,
        ease: 'power2.out',
      });
    });
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.5 }
    );

    if (barsRef.current[0]) {
      observer.observe(barsRef.current[0].closest('.our-skillbar'));
    }

    return () => observer.disconnect();
  }, []);

  return (
    <>
      {/* Our Skill Start */}
      <div className="our-skill">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="our-skill-content">
                <div className="section-title">
                  <h3 className="wow fadeInUp">our skills</h3>
                  <h2 className="text-anime-style-2" data-cursor="-opaque">
                    Skills that shape your<span> dream home</span>
                  </h2>
                  <p className="wow fadeInUp" data-wow-delay="0.2s">
                    Our dedicated team of designers works closely with you to understand your vision
                    and bring it to life with thoughtful attention to detail.
                  </p>
                </div>

                {/* Dynamic Skill Bars */}
                <div className="our-skillbar">
                  {skills.map((skill, index) => (
                    <div className="skills-progress-bar" key={index}>
                      <div className="skillbar" data-percent={skill.percent}>
                        <div className="skill-data">
                          <div className="skill-title">{skill.name}</div>
                          <div className="skill-no">{skill.percent}</div>
                        </div>
                        <div className="skill-progress">
                          <div
                            className="count-bar"
                            ref={(el) => (barsRef.current[index] = el)}
                            style={{
                              width: visible ? skill.percent : '0%',
                              transition: 'width 2s ease',
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Skill Images */}
            <div className="col-lg-6">
              <div className="our-skill-image">
                <div className="our-skill-img-1">
                  <figure className="image-anime reveal" ref={addRevealRef} style={{ opacity: 0 }}>
                    <img src="images/our-skill-img-1.jpg" alt="" />
                  </figure>
                </div>
                <div className="our-skill-img-2">
                  <figure className="image-anime reveal" ref={addRevealRef} style={{ opacity: 0 }}>
                    <img src="images/our-skill-img-2.jpg" alt="" />
                  </figure>
                </div>
                <div className="our-skill-img-3">
                  <figure className="image-anime reveal" ref={addRevealRef} style={{ opacity: 0 }}>
                    <img src="images/our-skill-img-3.jpg" alt="" />
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Our Skill End */}
    </>
  );
};

export default OurSkills;
